import React from 'react';
import { connect } from 'react-redux';

import Button from 'components/form/Button.component';
import InlineSpinner from 'components/generic/InlineSpinner.component';
import { useTranslation } from 'providers/GILT.provider';
import selectReqStatVoidTransaction from 'selectors/selectReqStatVoidTransaction.selector';

import CN from './RefundButton.module.scss';

const RefundButton = ({ disabled, onClick, isLoading }) => {
  const { t } = useTranslation();

  if (isLoading) {
    return <InlineSpinner />;
  }

  return (
    <Button variant="primary" onClick={onClick} disabled={disabled}>
      <span className={CN.wrapText}>{t('cashUp.cashupLogs.buttons.refundEdit')}</span>
    </Button>
  );
};

const mapStateToProps = (state) => ({
  isLoading: selectReqStatVoidTransaction(state),
});

// noinspection JSUnusedGlobalSymbols
export default connect(mapStateToProps)(RefundButton);
